if (!customElements.get('video-swiper')) {
    class VideoSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.mySwiper = new Swiper(this.querySelector(`.about_us_video_swiper`), {
                slidesPerView: 1,
                spaceBetween: 0,
                observer: true,
                touchMove: true,
                resizeObserver: true,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                },
                pagination: {
                    el: this.querySelector(`.swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`.swiper-scrollbar`),
                    draggable: true,
                },
            });
            this.videos = this.querySelectorAll('video');
            this.video_mask = this.querySelectorAll('.video_mask');
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {
            this.pauseAllVideos();
        }
        initEvent(swiper) {
            this.pauseAllVideos();

            this.video_mask.forEach(function (ele) {
                ele.querySelector('.pause_btn').addEventListener('click', function () {
                    ele.previousElementSibling.play()
                    ele.display = 'none';
                     ele.previousElementSibling.setAttribute('controls', 'controls');
                })
            });

            // 暂停时显示按钮
            this.videos.forEach(function (video) {
                video.addEventListener('pause', function () {
                    video.nextElementSibling.style.display = 'block';
                      video.setAttribute('controls', '');
                });
                video.addEventListener('play', function () {
                    video.nextElementSibling.style.display = 'none';
                  video.setAttribute('controls', 'controls');
                });
                video.addEventListener('ended', function () {
                    video.currentTime = 0;
                });
    
            });
        }
        // 暂停所有视频播放
        pauseAllVideos() {
            this.videos.forEach(function (video) {
                video.pause();
            });
        }
    }

    customElements.define('video-swiper', VideoSwiper);
}

